import React, { useState, useEffect, useRef } from 'react';
import './AssignExam.css';
import { fetchExamMasterList } from '../../../../api/examMasterListApi';
import { fetchExamTypes } from '../../../../api/examApi';
import { fetchAssignmentType } from '../../../../api/assignmentApi';
import { createUserAssignment } from '../../../../api/userAssignmentControllerApi'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { fetchTrainings } from '../../../../api/trainingApi';

const AssignExam = () => {
  const [studentName, setStudentName] = useState('');
  const [studentEmail, setStudentEmail] = useState('');
  const [studentMobile, setStudentMobile] = useState('');
  const [assignmentType, setAssignmentType] = useState('');
  const [examType, setExamType] = useState('');
  const [examMaster, setExamMaster] = useState('');
  const [examMasterName, setExamMasterName] = useState(''); 
  const [formError, setFormError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const [assignmentTypes, setAssignmentTypes] = useState([]);
  const [examTypes, setExamTypes] = useState([]);
  const [exams, setExams] = useState([]);
  const [trainings, setTrainings] = useState([]); 
  const [selectedTrainings, setSelectedTrainings] = useState([]); 
  const [selectedExamMasters, setSelectedExamMasters] = useState([]);
  const [examMasterNames, setExamMasterNames] = useState([]); 

  const [selectAllTrainings, setSelectAllTrainings] = useState(false);
  const [selectAllExams, setSelectAllExams] = useState(false);

  const dropdownRef = useRef(null);

  const [isAssigning, setIsAssigning] = useState(false);

  const [trainingType, setTrainingType] = useState('');

  useEffect(() => {
    document.title = 'Assign Exam - Finhaat Gurukul';
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [assignmentTypesData, examTypesData, examsData, trainingsData] = await Promise.all([
          fetchAssignmentType(),
          fetchExamTypes(),
          fetchExamMasterList(),
          fetchTrainings() 
        ]);
        setAssignmentTypes(assignmentTypesData);
        setExamTypes(examTypesData);
        setExams(examsData);
        setTrainings(trainingsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNameChange = (e) => setStudentName(e.target.value);
  const handleEmailChange = (e) => setStudentEmail(e.target.value);
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      setStudentMobile(value);
    }
  };
  const handleAssignmentTypeChange = (e) => {
    setAssignmentType(e.target.value);
    setExamType('');
    setExamMaster('');
    setExamMasterName('');
    setSelectedTrainings([]);
    setSelectedExamMasters([]);
    setExamMasterNames([]);
    setTrainingType('');
  };
  const handleExamTypeChange = (e) => {
    setExamType(e.target.value);
    setExamMaster('');
    setExamMasterName(''); 
  };

  const handleExamMasterChange = (exam) => {
    if (exam === 'all') {
      if (selectAllExams) {
        setSelectedExamMasters([]);
        setExamMasterNames([]);
      } else {
        const filteredExams = exams.filter(e => e.examType.examTypeId.toString() === examType);
        setSelectedExamMasters(filteredExams.map(e => e.examId));
        setExamMasterNames(filteredExams.map(e => e.examName));
      }
      setSelectAllExams(!selectAllExams);
    } else {
      setSelectedExamMasters(prev => {
        if (prev.includes(exam.examId)) {
          return prev.filter(id => id !== exam.examId);
        } else {
          return [...prev, exam.examId];
        }
      });
      setExamMasterNames(prev => {
        if (prev.includes(exam.examName)) {
          return prev.filter(name => name !== exam.examName);
        } else {
          return [...prev, exam.examName];
        }
      });
    }
  };

  // const handleTrainingChange = (trainingId) => {
  //   if (trainingId === 'all') {
  //     if (selectAllTrainings) {
  //       setSelectedTrainings([]);
  //     } else {
  //       setSelectedTrainings(trainings.map(t => t.trainingId.toString()));
  //     }
  //     setSelectAllTrainings(!selectAllTrainings);
  //   } else {
  //     setSelectedTrainings(prev => {
  //       if (prev.includes(trainingId)) {
  //         return prev.filter(id => id !== trainingId);
  //       } else {
  //         return [...prev, trainingId];
  //       }
  //     });
  //   }
  // };

  const handleTrainingChange = (trainingId) => {
    if (trainingId === 'all') {
      if (selectAllTrainings) {
        setSelectedTrainings([]);
      } else {
     
        const filteredTrainings = trainings
          .filter(t => t.examTypeId && t.examTypeId.toString() === trainingType.toString())
          .map(t => t.trainingId.toString());
        setSelectedTrainings(filteredTrainings);
      }
      setSelectAllTrainings(!selectAllTrainings);
    } else {
      setSelectedTrainings(prev => {
        if (prev.includes(trainingId)) {
          return prev.filter(id => id !== trainingId);
        } else {
          return [...prev, trainingId];
        }
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownVisible(true);
  };

  const handleInputClick = () => {
    setIsDropdownVisible((prev) => !prev); 
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    return mobile.length === 10;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!studentName || !studentEmail || !studentMobile || !assignmentType) {
      setFormError('Please fill in all required fields.');
      return;
    }

    if (!validateEmail(studentEmail)) {
      setFormError('Please enter a valid email address.');
      return;
    }

    if (!validateMobile(studentMobile)) {
      setFormError('Please enter a valid 10-digit mobile number.');
      return;
    }

    if (assignmentType === '1' && selectedTrainings.length === 0) {
      setFormError('Please select at least one Training.');
      return;
    }

    if ((assignmentType === '2' || assignmentType === '3') && (!examType || selectedExamMasters.length === 0)) {
      setFormError(`Please select ${getTypeLabel()} and at least one ${getMasterLabel()}.`);
      return;
    }

    setFormError('');
    setIsAssigning(true);

    const assignmentPayload = {
      userAssignmentId: 0,
      user: {
        userMasterId: 0,
        userId: studentEmail,
        userName: studentName,
        email: studentEmail,
        mobileNo: studentMobile,
        userRole: 0,
        isActive: 0,
        isDeleted: 0
      },
      assignmentType: {
        assignmentTypeId: parseInt(assignmentType, 10),
        assignmentName: assignmentTypes.find(type => type.assignmentTypeId.toString() === assignmentType)?.assignmentName || ''
      },
      assignmentId: assignmentType === '1' ? selectedTrainings.map(id => parseInt(id, 10)) : selectedExamMasters
    };

    try {
      await createUserAssignment(assignmentPayload);
      toast.success('Assignment Successfully Created!', {
        onClose: () => {
          setStudentName('');
          setStudentEmail('');
          setStudentMobile('');
          setAssignmentType('');
          setExamType('');
          setExamMaster('');
          setExamMasterName('');
          setSelectedTrainings([]);
          setSelectedExamMasters([]);
          setExamMasterNames([]);
        }
      });
    } catch (error) {
      console.error('Error creating assignment:', error);
      toast.error('An error occurred while creating the assignment.');
    } finally {
      setIsAssigning(false);
    }
  };

  const handleTrainingTypeChange = (e) => {
    setTrainingType(e.target.value);
    setSelectedTrainings([]);
  };

  const shouldShowExamFields = assignmentType === '2' || assignmentType === '3';
  const shouldShowTrainingField = assignmentType === '1';

  const getTypeLabel = () => assignmentType === '3' ? 'Mock Type' : 'Exam Type';
  const getMasterLabel = () => assignmentType === '3' ? 'Mock Master' : 'Exam Master';

  const trainingSelectionJSX = (
    <>
      <div className="form-block">
        <div className="form-group">
          <label>Training Type:</label>
          <select 
            required 
            className="form-input"
            value={trainingType}
            onChange={handleTrainingTypeChange}
          >
            <option value="">Select Training Type</option>
            {examTypes.map((type) => (
              <option key={type.examTypeId} value={type.examTypeId}>
                {type.examTypeDesc}
              </option>
            ))}
          </select>
        </div>
      </div>

      {trainingType && (
        <div className="form-block">
          <div className="form-group">
            <label>Training:</label>
            <div className="custom-dropdown" ref={dropdownRef}>
              <div className="selected-items" onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
                {selectedTrainings.length > 0 ? 
                  trainings
                    .filter(t => selectedTrainings.includes(t.trainingId?.toString()))
                    .map(t => t.trainingName)
                    .join(', ') 
                  : 'Select Training'}
              </div>
              {isDropdownVisible && (
                <div className="dropdown-list">
                  <label className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectAllTrainings}
                      onChange={() => handleTrainingChange('all')}
                    />
                    <span>Select All</span>
                  </label>
                  {trainings
                    .filter(training => training.examTypeId && training.examTypeId.toString() === trainingType.toString())
                    .map((training) => (
                      <label key={training.trainingId} className="dropdown-item">
                        <input
                          type="checkbox"
                          checked={selectedTrainings.includes(training.trainingId?.toString())}
                          onChange={() => handleTrainingChange(training.trainingId?.toString())}
                        />
                        <span>{training.trainingName}</span>
                      </label>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );

  const examMasterSelectionJSX = (
    <div className="form-block">
      <div className="form-group">
        <label>{getMasterLabel()}:</label>
        <div className="custom-dropdown" ref={dropdownRef}>
          <div className="selected-items" onClick={() => setIsDropdownVisible(!isDropdownVisible)}>
            {examMasterNames.length > 0 ? examMasterNames.join(', ') : `Search or Select ${getMasterLabel()}...`}
          </div>
          {isDropdownVisible && (
            <div className="dropdown-list">
              <label className="dropdown-item">
                <input
                  type="checkbox"
                  checked={selectAllExams}
                  onChange={() => handleExamMasterChange('all')}
                />
                <span>Select All</span>
              </label>
              {exams
                .filter(exam => 
                  exam.examType.examTypeId.toString() === examType &&
                  exam.examName.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((exam) => (
                  <label key={exam.examId} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedExamMasters.includes(exam.examId)}
                      onChange={() => handleExamMasterChange(exam)}
                    />
                    <span>{exam.examName}</span>
                  </label>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="assign-exam-container">
       <ToastContainer 
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
      <form onSubmit={handleSubmit} className="assign-exam-form">
        <div className="form-block">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              value={studentName}
              onChange={handleNameChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={studentEmail}
              onChange={handleEmailChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Mobile No.:</label>
            <input
              type="tel"
              value={studentMobile}
              onChange={handleMobileChange}
              className="form-input"
              maxLength="10"
              pattern="[0-9]{10}"
              title="Please enter a 10-digit mobile number"
            />
          </div>
        </div>

        {formError && <p className="form-error">{formError}</p>}

        <div className="form-block">
          <div className="form-group">
            <label>Assignment Type:</label>
            <select 
              required 
              className="form-input"
              value={assignmentType}
              onChange={handleAssignmentTypeChange}
            >
              <option value="">Select Assignment Type</option>
              {assignmentTypes.map((type) => (
                <option key={type.assignmentTypeId} value={type.assignmentTypeId}>
                  {type.assignmentName}
                </option>
              ))}
            </select>
          </div>
        </div>

        {shouldShowTrainingField && trainingSelectionJSX}

        {shouldShowExamFields && (
          <>
            <div className="form-block">
              <div className="form-group">
                <label>{getTypeLabel()}:</label>
                <select 
                  required 
                  className="form-input"
                  value={examType}
                  onChange={handleExamTypeChange}
                >
                  <option value="">Select {getTypeLabel()}</option>
                  {examTypes.map((type) => (
                    <option key={type.examTypeId} value={type.examTypeId}>
                      {type.examTypeDesc}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {examType && examMasterSelectionJSX}
          </>
        )}
        
        <div className='user-assignment-btn-email-assign'>
          <button
            type="submit"
            className="assign-submit-btn"
            disabled={isAssigning}
          >
            {isAssigning ? 'Assigning...' : shouldShowExamFields 
              ? `Assign ${assignmentType === '3' ? 'Mock' : 'Exam'}`
              : shouldShowTrainingField
                ? 'Assign Training'
                : 'Assign'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AssignExam;